module.exports = __webpack_public_path__ + "static/media/loja.5fb30e4b.jpg";